// #region Imports

import Vue from 'vue';
// io.sales Page-Components
import './sales-pages';

// #endregion

// #region Component Registration

Vue.component('SalesportalReportsPageConfig', () => import(/* webpackChunkName: "base-components" */ '@/order/components/partner/SalesportalReportsPageConfig.vue'));

// #endregion
